<div class="container-fluid">
    <div class="row table-header fw-bold py-2">
        <div class="col-1"></div>
        <div class="col-lg-2 col-5" (click)="setOrderBy(firstColumnLabel)">
            <span
                [translate]="
                    isCustomerTab
                        ? 'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_EQUIPMENT'
                        : 'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_NOTIFICATION_NUMBER'
                "
            ></span>
            <span class="sort-order" [hidden]="orderBy !== firstColumnLabel" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-lg-1 col-2" (click)="setOrderBy('notificationType')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_TYPE'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'notificationType'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-1 d-none d-lg-block" (click)="setOrderBy('taskCode')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_TASK'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'taskCode'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-1 d-none d-lg-block" (click)="setOrderBy('shortText')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_SHORT_TEXT'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'shortText'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-1 d-none d-lg-block" (click)="setOrderBy('showMatIcon')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_MATERIAL'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'showMatIcon'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-2 d-none d-lg-block" (click)="setOrderBy('plannedDate')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_PLANNED_DATE'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'plannedDate'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-1 d-none d-lg-block" (click)="setOrderBy('deadline')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_DEADLINE'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'deadline'" [ngClass]="{ reverse: reverse }"></span>
        </div>
        <div class="col-lg-2 col-4 text-center" (click)="setOrderBy('canGetTask')">
            <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_TABLE_ACTIONS'"> </span>
            <span class="sort-order" [hidden]="orderBy !== 'canGetTask'" [ngClass]="{ reverse: reverse }"></span>
        </div>
    </div>
    @if (!state?.isLoading && !state?.hasError) {
        @if (tasks?.length > 0) {
            <div class="material-stock-content">
                @for (task of tasks | orderBy: orderBy : reverse; track task) {
                    <div class="row table-row">
                        <pace-other-tasks-expandable-row
                            [task]="task"
                            [isCustomerTab]="isCustomerTab"
                            (getTask)="getTaskClickHandler($event)"
                        ></pace-other-tasks-expandable-row>
                    </div>
                }
            </div>
        } @else {
            <div
                class="text-center text-muted p-3"
                [translate]="'NOTIFICATION_DETAIL_OTHER_TASKS_NO_TASKS_FOUND'"
            ></div>
        }
        <!-- No records template -->
    }
</div>

@if (state?.hasError) {
    <div class="text-danger mt-3 mb-3" [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_ERROR'"></div>
}
@if (state?.isLoading) {
    <progressbar [striped]="true" [value]="100" type="default" class="mt-5">
        <span [translate]="'NOTIFICATION_DETAIL_EQUIPMENTS_OTHER_TASKS_LOADING'"></span>
    </progressbar>
}
